import { useEffect, useState } from 'react';
import { ReactComponent as LeftArrow } from '../../../common/assets/magicMovie/left-arrow.svg';
import { ReactComponent as RightArrow } from '../../../common/assets/magicMovie/right-arrow.svg';

interface Tab {
  name: any;
  id: string;
}

interface ISelectedSetCount {
  [key: string]: number;
}

interface TabsProps {
  tabs: Tab[];
  selectedTab: string;
  selectedSetCount?: ISelectedSetCount;
  onTabChange: (tabId: string) => void;
  maxWidth?: number;
}

const Tabs: React.FC<TabsProps> = (props) => {
  const { tabs, selectedTab, selectedSetCount, onTabChange, maxWidth = 1000 } = props;
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const parentTabContainer = document.getElementById('movie-grid-root-scrollable-container');
    setIsScrollable((parentTabContainer?.offsetWidth && parentTabContainer?.offsetWidth <= maxWidth - 30) || false);
    window.addEventListener('resize', function () {
      setIsScrollable((parentTabContainer?.offsetWidth && parentTabContainer?.offsetWidth <= maxWidth - 30) || false);
    });
  }, [maxWidth]);

  const handleScroll = (direction = 'left') => {
    const scrollableContainer = document.getElementById('movie-grid-root-scrollable-container');
    if (scrollableContainer) {
      /** Scroll to right or left by 130 pixels everytime icon is clicked */
      scrollableContainer.scrollBy({
        left: direction === 'left' ? -130 : 130,
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="tab-root-container">
      {isScrollable && (
        <>
          <div
            className="tab-scroll-buttons tab-scroll-button-left"
            id="tab-scroll-button-left"
            onClick={() => {
              handleScroll('left');
            }}
          >
            <LeftArrow />
          </div>
          <div
            className="tab-scroll-buttons tab-scroll-button-right"
            id="tab-scroll-button-right"
            onClick={() => {
              handleScroll('right');
            }}
          >
            <RightArrow />
          </div>
        </>
      )}
      <div className="tab-container-parent" id="movie-grid-root-scrollable-container">
        <div
          className="movie-tab-inner-container"
          style={{
            width: maxWidth + 'px',
          }}
        >
          {tabs.map((tab) => {
            const selectedItemCount = selectedSetCount?.[tab.id] || 0;
            return (
              <div key={tab.id} className="tab">
                <a
                  className={tab.id === selectedTab ? 'selected' : ''}
                  onClick={() => {
                    onTabChange(tab.id);
                  }}
                >
                  {tab.name}{' '}
                </a>
                <span className={`${selectedItemCount > 0 ? 'badge' : 'emptyBadge'}`}>
                  {selectedItemCount > 0 ? selectedItemCount : ''}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Tabs;
